import { ISPFEService, SPFEService } from "@services/proyecta/spfe.service";
import {
  ProaService,
  IProaService,
} from "@services/proyecta/proa-form.service";
import { useSelector } from "react-redux";
import { queryString, Utilities } from "@utils";
import { ProaFormFEPresenterExtension } from "@presenters/screens/form-proa-fe-extension.presenter";
import { IFormProaFE } from "@interfaces/screens/form-proa-fe.interface";
import DataGrid from "devextreme/ui/data_grid";
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";

import {
  IProaFormBasicDataMasters,
  ILang,
  IFEStep1Anio,
  IFileDto,
  IFEStep1Beneficiario,
  IFEStep2DtoModel,
  IFEStep2Anio,
  IFEStepSDCAnio,
  IFEStep2,
  IFEStepSDC,
  IFEStep3,
  IFEStep3Anios,
  IFEStep3DtoModel,
  IFEStep1Dto,
  IFEStep2Dto,
  IFEStepSDCDto,
  IFEStep3Dto,
  IFEStep4,
  IFEStep4Dto,
  IFEStep4IndicadorObjetivo,
  IFEStep4IndicadorObjetivoAnio,
  IFEStep4ResultsDtoModel,
  IFEStep4ResultadoEsperado,
  IFEStep4ResultadoEsperadoDetalle,
  IFEStep4ResultadoEsperadoDetalleAnio,
} from "@models/*";
import { AEAFieldProps } from "@/components/ui/aea-field/aea-field";
import {
  Enums,
  String,
  IDataTable,
  GridUtilities,
  moment,
  Constants,
} from "@utils";
import { IFEStep4Actividad, IFEStep4ActividadAnio, IFEStep4IndicadorMri, IFEStep4MriIndicadorAnio, IFEStep4MriIndicadorDtoModel } from "@/models/spfe.model";
import { addSyntheticLeadingComment } from "typescript";

export class FormProaFEPresenter extends ProaFormFEPresenterExtension {
  private _feService: ISPFEService;
  private _proaService: IProaService;
  private _subventionCodeId: number;
  private _grantCode: string;
  public params: any;
  public currentBudget: any;
  public currentBudgetDetails: any;
  public currentLang: ILang;
  public formMasters: IProaFormBasicDataMasters;
  public progress: number;

  constructor(view: IFormProaFE) {
    super(view);
    this._subventionCodeId = this.view.state.subventionCodeId;
    this._grantCode = this.view.state.grantCode;

    this._feService = new SPFEService();
    this._proaService = new ProaService();

    this.params = useSelector(this.context.sessionStore.selectParams);
    this.currentBudget = useSelector(this.context.proaStore.selectCurrentBudget) as any;
    this.currentBudgetDetails = useSelector(this.context.proaStore.selectCurrentBudgetDetails) as any;
    this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters) as any;
    this.progress = useSelector(this.context.sessionStore.selectProgress);

    this.addNewObjetive = this.addNewObjetive.bind(this);
    this.addFile = this.addFile.bind(this);
    this.openCloseModal = this.openCloseModal.bind(this);
    this.openCloseModalExcel = this.openCloseModalExcel.bind(this);
    this.addNewExpectedResult = this.addNewExpectedResult.bind(this);
    this.onCellPreRender = this.onCellPreRender.bind(this);
    this.saveTable = this.saveTable.bind(this);
    this.checkConsolidateADT = this.checkConsolidateADT.bind(this);
    this.checkConsolidateValues = this.checkConsolidateValues.bind(this);
    this.handleChangeValueObjRes = this.handleChangeValueObjRes.bind(this);
    this.handleChangeValueAct = this.handleChangeValueAct.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.checkActivitiesBudget = this.checkActivitiesBudget.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);
  }
  public getReadOnly() {
    const readOnly: boolean = window.location.href.indexOf("view?Id") > -1;
    this.view.state.setReadOnly(readOnly);
    return readOnly;
  }
  public async saveTable(stepData: any, section: string, objIndex?: number, tabIndex?: number, resIndex?: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    try {
      let userEmail = this.currentUser.currentUser.userPrincipalName;
      let infoS4 = (section !== 'Mri') ? this.mapBasicDataToDTO(objIndex) : null

      if (section !== 'Mri' && !!infoS4 && !infoS4?.Id) {
        Utilities.notifyError('Debe guardar primero la información básica del objetivo', 'Error');
        return;
      }

      let response: any = null, canSave = false

      if (section === 'Obj') {
        response = this.mapBasicDataObjetivesTableToDTO(objIndex, tabIndex)
        if (response?.length) canSave = true
      } else if (section === 'Mri') {
        response = this.mapBasicDataMriTableToDTO(tabIndex)
        if (response?.length) canSave = true
      } else if (section === 'Res' || section === 'Act') {
        response = this.mapExpectedResultsToDTO(tabIndex, objIndex, true)
        if (section === 'Res' && response?.[resIndex]?.details?.length) canSave = true
        else if (section === 'Act' && response?.[resIndex]?.activities?.length) canSave = true
      }

      if (!canSave) return;


      /* if(!!infoS4 && !infoS4?.Id){
        let res = await this._feService.createInfoStep4(infoS4)
        infoS4 = res
        stepData[objIndex].genericInfo = res
  
        if(tabIndex >= 0) this.consult?.()
      } */
      if (section === 'Obj') {
        let res = await this._feService.saveObjetivesS4(infoS4, response, userEmail)
        res.forEach((x: any, i: number) => {
          response[i]?.years?.forEach((y: any) => {
            if (!y?.Id) y.Id = x?.years?.find((z: any) => (Number(z?.data?.PPresAnioMeta) === Number(y.PPresAnioMeta)))?.data?.Id;
          })
          if (response[i]?.genericInfo && !response[i]?.genericInfo?.Id) response[i].genericInfo.Id = x.Id
        })
        stepData[objIndex].objetives = response

        this.view.setPartialSave(stepData)
      } else if (section === 'Mri') {
        let res = await this._feService.saveMriS4(response, userEmail)
        res.forEach((x: any, i: number) => {
          response[i]?.years?.forEach((y: any) => {
            if (!y?.Id) y.Id = x?.years?.find((z: any) => (Number(z?.data?.PPresAnioMeta) === Number(y.PPresAnioMeta)))?.data?.Id;
          })
          if (response[i]?.genericInfo && !response[i]?.genericInfo?.Id) response[i].genericInfo.Id = x.Id
        })
        /* let mriData = this.view.state.mriIndicatorsGridData
         mriData.dataSource = []
         if(!!mriData.auxData) mriData.auxData = mriData.auxData.filter((x: any) => !x.__KEY__)
         this.view.state.setMriIndicatorsGridData(mriData)*/
        this.view.setPartialSave(response)
        this.view.refreshPage(!this.view.refresh)
      } else if (section === 'Res' || section === 'Act') {
        let currentRes = response?.[resIndex]
        if (!currentRes?.genericInfo?.Id && currentRes) {
          Utilities.notifyError('Debe guardar primero la información básica del resultado esperado', 'Error');
          return;
          /* currentRes.genericInfo.PProaFEStep4Id = infoS4.Id
          let res2 = await this._feService.createResInfoStep4(currentRes?.genericInfo)
          currentRes.genericInfo = res2 */
        }
        let res: any = null
        if (section === 'Res') res = await this._feService.saveEspResults(currentRes, currentRes?.genericInfo, userEmail)
        if (section === 'Act') res = await this._feService.saveActivities(currentRes, currentRes?.genericInfo, userEmail, true)

        stepData[objIndex].results[resIndex] = res

        this.view.setPartialSave(stepData)
      }

      this.view.handleLoad(section)
      setTimeout(() => {
        Utilities.notifySuccess(this.currentLabels.get("Guardado exitoso"), this.currentLabels.get("Guardar"))
      }, 300);
    } catch (error) {
      setTimeout(() => {
        Utilities.notifyError("Ha ocurrido un error guardando la información.", "Error")
      }, 300);
    }
  }
  public checkRequiredFields(columns: any, item: any, checkBaseLine: boolean = true) {
    let message: any = null
    let columnIds = columns.map((x: any) => {
      let field = x.dataField
      let value = Array.isArray(item[field]) ? item[field]?.[0] : item[field]

      if (field === Enums.ProaBasicFields.PProaMetaFinanciera || field === Enums.ProaBasicFields.PProaUnidadMedida || field === Enums.ProaBasicFields.PProaMetaMRI ||
        field === Enums.ProaBasicFields.PProaMedidaId || field === Enums.ProaBasicFields.PProaValorActividad || field === Enums.ProaBasicFields.MetaFinal ||
        field?.includes(Enums.ProaBasicFields.MetaValor) || field?.includes(Enums.ProaBasicFields.SubTotal) || field === Enums.ProaBasicFields.MetaTotalProyecto ||
        (checkBaseLine && field === Enums.ProaBasicFields.PProaAnioLineaBase && !value)) {
        let auxMessage = this.currentLabels.get("AlertReqFields")
        if (!value && value !== 0 && (message === auxMessage || !message)) {
          message = auxMessage
          return x.visibleIndex
        }
      } else if (Utilities.isNullEmptyObject(item[Enums.ProaBasicFields.LineaBase]) && (checkBaseLine && field === Enums.ProaBasicFields.PProaAnioLineaBase)) {
        let auxDate = value
        auxDate = auxDate ? typeof auxDate.getMonth !== 'function' ? new Date(auxDate.split('/')[1], Number(auxDate.split('/')[0]) - 1, 1) : auxDate : auxDate;
        let currentDate = new Date()
        let wrongDate = auxDate ? (auxDate.getFullYear() === currentDate.getFullYear()) ? (auxDate.getMonth() < currentDate.getMonth()) : (auxDate.getFullYear() < currentDate.getFullYear()) : true
        let auxMessage = this.currentLabels.get("AlertBaseLineYear")
        if (wrongDate && (message === auxMessage || !message)) {
          message = auxMessage
          return x.visibleIndex
        }
      }
    })

    columnIds = columnIds.filter((x: any) => x >= 0)

    return { columnIds, message }
  }

  public checkActivitiesBudget(columns: any, item: any) {
    let message2: any = null
    let columnMeta = columns.find((y: any) => y.dataField === Enums.ProaBasicFields.PProaValorActividad)?.visibleIndex
    let sumBudget = 0

    columns.map((x: any) => {
      let field = x.dataField
      if (field?.includes(Enums.ProaBasicFields.MetaValor)) {
        sumBudget += (item[field] || 0)
      }
    })

    let columnIds2 = (item[Enums.ProaBasicFields.PProaValorActividad] < sumBudget) ? [columnMeta] : []

    if (columnIds2?.length) message2 = this.currentLabels.get("AlertMinTotalBudget")

    return { columnIds2, message2 }
  }

  public checkEndDate(columns: any, item: any) {
    let message: any = null
    const endYear = this.view.state.endDate ? new Date(this.view.state.endDate).getFullYear() : this.view.endDate ? new Date(this.view.endDate).getFullYear() : null;

    if (!endYear) return { columnIds: [], message }

    let columnIds = columns.map((x: any) => {
      let field = x.dataField
      if (field?.includes(Enums.ProaBasicFields.MetaValor) || field?.includes(Enums.ProaBasicFields.SubTotal)) {
        let year = field?.split("-")?.[1] ? Number(field.split("-")[1]) : null
        if (!!year && year > endYear) return x.visibleIndex;
      } else if (field === Enums.ProaBasicFields.BeneficiarioAnio) {
        let year = item[Enums.ProaBasicFields.BeneficiarioAnio] ? Number(item[Enums.ProaBasicFields.BeneficiarioAnio]) : null
        if (!!year && year > endYear) return x.visibleIndex;
      }
    })

    columnIds = columnIds.filter((x: any) => x >= 0)

    return { columnIds, message }
  }

  public handleChangeValue(option: any, isAct: boolean = false) {
    let message = null
    if (!!option?.data || !!option?.data?.__KEY__) {
      let field = option?.dataField
      let value = option.data[field]

      if (((field?.includes(Enums.ProaBasicFields.MetaValor) && !isAct) || field?.includes(Enums.ProaBasicFields.SubTotal) || field === Enums.ProaBasicFields.PProaMetaFinanciera ||
        field === Enums.ProaBasicFields.MetaFinal || field === Enums.ProaBasicFields.PProaMetaMRI) && !Utilities.isNullEmptyObject(value)) {
        let dataKeys: any = Object.keys(option.data) || []
        let isMultiYear = dataKeys.filter((x: any) => x?.includes(Enums.ProaBasicFields.MetaValor))?.length > 1
        if (value === 0)
          message = this.currentLabels.get("ToastGoalCero")
        else if (value <= option.data[Enums.ProaBasicFields.LineaBase])
          message = this.currentLabels.get("ToastGoalBaseLine")
        else if (isMultiYear && field?.includes(Enums.ProaBasicFields.MetaValor)) {
          if (value === option.data[Enums.ProaBasicFields.PProaMetaFinanciera] ||
            value === option.data[Enums.ProaBasicFields.MetaFinal] ||
            value === option.data[Enums.ProaBasicFields.PProaMetaMRI]
          )
            message = this.currentLabels.get("ToastYearGoal")
        }
      }

    }
    return message
  }

  public handleChangeValueAct(option: any) {
    let message = null
    if (!!option?.data || option?.data?.__KEY__) {
      let field = option?.dataField
      let value = option.data[field]
      if ((field?.includes(Enums.ProaBasicFields.MetaValor) || field === Enums.ProaBasicFields.PProaValorActividad) && value === 0) {
        message = this.currentLabels.get("ToastBudgetCero")
      }
    }
    return message
  }

  public handleChangeValueObjRes(option: any) {
    let message = null
    if (!!option?.data || option?.data?.__KEY__) {
      let field = option?.dataField
      let value = option.data[field]
      if (field === Enums.ProaBasicFields.LineaBase && value === 0) {
        message = this.currentLabels.get("ToastBaseLineCero")
      }
    }
    return message
  }

  public checkConsolidateValues(item: any, tableData2: any, withMessage: boolean = false) {

    let totalTable2: any = Object.keys(tableData2)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let currentKeys: any = Object.keys(item)
    let message: any = null

    let columnIds = currentKeys.map((_key: any, index: number) => {
      if (_key.includes(Enums.ProaBasicFields.MetaValor)) {
        if (Number(item[_key]?.toFixed?.(2)) !== Number(tableData2?.[_key]?.toFixed?.(2))) return index
      } else if (Number(item[_key]?.toFixed?.(2)) !== Number(tableData2?.[totalTable2]?.toFixed?.(2))) return index
    })

    columnIds = columnIds.filter((x: any) => (!Utilities.isNullEmptyObject(x) && x >= 0))
    if (columnIds?.length && withMessage) {
      message = this.currentLabels.get("AlertConsolidateValuesWithoutLoc")
    }

    return { columnIds, message }
  }

  public checkConsolidateADT(adtData: any, impData: any, locData: any, actData: any, withMessage: boolean = false) {
    let totalImp: any = Object.keys(impData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let totalLoc: any = Object.keys(locData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let totalAct: any = Object.keys(actData)?.find((x: any) => !x.includes(Enums.ProaBasicFields.MetaValor))
    let currentKeys: any = Object.keys(adtData)
    let message: any = null
    let thereLoc: boolean = false

    let columnIds = currentKeys.map((_key: any, index: number) => {
      if (!thereLoc) thereLoc = (!!locData?.[_key] || !!locData?.[totalLoc])
      if (_key.includes(Enums.ProaBasicFields.MetaValor)) {
        if (Number(adtData[_key]?.toFixed?.(2)) > Number(impData?.[_key]?.toFixed?.(2)) ||
          (!!locData?.[_key] && Number(adtData[_key]?.toFixed?.(2)) > Number(locData?.[_key]?.toFixed?.(2))) ||
          Number(adtData[_key]?.toFixed?.(2)) > Number(actData?.[_key]?.toFixed?.(2))) return index
      } else if (Number(adtData[_key]?.toFixed?.(2)) > Number(impData?.[totalImp]?.toFixed?.(2)) ||
        (!!locData?.[totalLoc] && Number(adtData[_key]?.toFixed?.(2)) > Number(locData?.[totalLoc]?.toFixed?.(2))) ||
        Number(adtData[_key]?.toFixed?.(2)) > Number(actData?.[totalAct]?.toFixed?.(2))) return index
    })

    columnIds = columnIds.filter((x: any) => (!Utilities.isNullEmptyObject(x) && x >= 0))
    if (columnIds?.length && withMessage) {
      if (thereLoc) message = this.currentLabels.get("AlertConsolidateAdt")
      else message = this.currentLabels.get("AlertConsolidateAdtWithoutLoc")
    }

    return { columnIds, message }
  }

  private getCommonFieldProps(fieldName: string) {
    if (!Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const fieldProps = this.view.state.dataColumns.get(fieldName);
      const field: AEAFieldProps = {
        showLabel: true,
        title: fieldProps?.NombreColumna || "",
        description: fieldProps?.OCTAVIATooltip || "",
        id: `${fieldProps?.Id || 0}_fe`,
        placeholder: fieldProps?.NombreColumna || "",
        fieldType: fieldProps?.TipoCampoProyecta || "text",
        requiredErrorMessage: this.currentLabels.get("campo obligatorio"),
        required: true,
        multiple: fieldProps?.OCTAVIAMultiple,
      };
      field.readOnly = this.view.state.readOnly
        ? this.view.state.readOnly
        : field.readOnly;
      return field;
    }
  }
  public get isContentReady() {
    return (
      !Utilities.isNullEmptyObject(this.currentBudget) &&
      !Utilities.isNullEmptyObject(this.currentLabels) &&
      !Utilities.isNullEmptyObject(this.formMasters) &&
      !Utilities.isNullEmptyObject(this.currentLang)
    );
  }
  //#region initialize form
  public async initStep1() {
    return await this._feService.getStepOne({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }
  public async getSpfeStep2() {
    return await this._feService.getStepTwo({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }
  public async getSpfeStep3() {
    return await this._feService.getStepThree({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }
  public async getSpfeStepSDC() {
    return await this._feService.getSDCStep({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }
  public async getSpfeStep4() {
    return await this._feService.getStepFour({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }
  public async getSpfeStep4MRI() {
    return await this._feService.getStepFourMRI({
      budgetId: this.getBudgetId(),
      subventionCodeId: this._subventionCodeId || this.view.state.subventionCodeId,
      grantCode: this.view.state.grantCode,
    });
  }

  private getBudgetId() {
    const query = queryString.parseUrl(window.location.href.replace("#", "")).query as any;
    return query.Id;
  }

  private async getHeaderGrouped(project: any, headerInformation: any) {
    let financers = [headerInformation[2].value]
    project.SubProyectosAgrupados.forEach(async (code: any, index: number) => {
      let result = await this._feService.getHeader({
        budgetId: this.currentBudget.Id,
        langLabel: this.currentLang.label,
        subvCode: code.Id,
      });
      if (result) {
        if (!financers.includes(result.financier)) financers.push(result.financier)
        headerInformation[5].value = headerInformation[5].value + ', ' + code.Title;

      }
      if (project.SubProyectosAgrupadosId.length == index + 1) {
        headerInformation[2].value = financers.join(', ')
        this.view.state.setHeaderInfo(headerInformation);
      }
    });

  }
  //#endregion
  /************************ */
  //#region header
  public async initializeHeaderInformation(projectsGrouped: any) {
    if (this.isContentReady) {
      const data = await this._feService.getHeader({
        budgetId: this.currentBudget.Id,
        langLabel: this.currentLang.label,
        subvCode: this.view.state.subventionCodeId,
      })

      const headerInformation = [
        { label: "Titulo de proyecto", value: data.projectTitle },
        { label: "Codigo proyecto", value: data.projectCode },
        { label: "Financiador", value: data.financier },
        { label: "Objetivo estrategico", value: data.strategicObjetive },
        { label: "Linea estrategica", value: data.strategicLine },
        { label: "CodigoSubvencion", value: this.formMasters?.grantCodes?.find((x: any) => x.Id === this.view.state.subventionCodeId)?.Title ?? "", },
      ];

      let project = projectsGrouped?.find((x: any) => this.view.state.subventionCodeId === x.PPresCodSubvencionId);
      if (project) this.getHeaderGrouped(project, headerInformation);
      else this.view.state.setHeaderInfo(headerInformation);
    }
  }
  //#endregion
  /*********************** */
  //#region Step 1
  //#region dates
  public get initDate() {
    const startDateInit = this.view.startDate != null && this.view.startDate != undefined ? typeof this.view.startDate === "string" ? this.view.startDate : this.view.startDate.toUTCString() : null;
    const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.FechaInicio),
      value: startDateInit !== null && startDateInit !== undefined ? Utilities.getDateEuropeTimeZone(startDateInit) : null,
      readOnly: true,
    };
    return field;
  }
  public get endDate() {
    const endDate = this.view.endDate != null && this.view.endDate != undefined
      ? typeof this.view.endDate === "string"
        ? Utilities.getDateEuropeTimeZone(this.view.endDate)
        : this.view.endDate.toUTCstring()
      : null;

    const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.FechaFin),
      value: endDate != null && endDate != undefined ? Utilities.getDateEuropeTimeZone(endDate) : null,
      readOnly: true,
    };
    return field;
  }

  public validEndDate() {
    let valid = true
    const endYear = this.view.endDate ? new Date(this.view.endDate).getFullYear() : null;
    if (Utilities.isNullEmptyObject(endYear)) return valid;

    let step1Data = this.view.step1Data
    let step2Data = this.view.step2Data
    let stepSDCData = this.view.stepSDCData
    let step3Data = this.view.step3Data
    let step4MRIData = this.view.step4MRIData
    let step4Data = this.view.step4Data

    if (!Utilities.isNullEmptyObject(step1Data) && valid) {
      step1Data?.baseLineYears?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
      step1Data?.beneficiaries?.forEach((year: any) => { if (Number(year?.PPresuAnio) > endYear) valid = false })
    }

    if (!Utilities.isNullEmptyObject(step2Data) && valid) {
      step2Data?.genericInfo?.[0]?.implementerYears?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
    }

    if (!Utilities.isNullEmptyObject(stepSDCData) && valid) {
      stepSDCData?.genericInfo?.[0]?.counterpartsYears?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
    }

    if (!Utilities.isNullEmptyObject(step3Data) && valid) {
      step3Data?.adts?.[0]?.details?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
      step3Data?.zones?.[0]?.details?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
    }

    if (!Utilities.isNullEmptyObject(step4MRIData) && valid) {
      step4MRIData?.[0]?.years?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
    }

    if (!Utilities.isNullEmptyObject(step4Data) && valid) {
      for (const step4 of step4Data) {
        step4?.objetives?.[0]?.years?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
        let results = step4?.results || []
        for (const res of results) {
          res?.activities?.[0]?.years?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
          res?.details?.[0]?.years?.forEach((year: any) => { if (Number(year?.PPresAnioMeta) > endYear) valid = false })
        }
      }
    }

    return valid
  }

  public validBeneficiaries() {
    let hasTotalBenef = false
    let data = this.view.step1Data
    if (!Utilities.isNullEmptyObject(data)) {
      data?.beneficiaries.forEach((be: any) => {
        if (Number(be.PPresTotalAnio) > 0 && !hasTotalBenef) hasTotalBenef = true
      })
    }
    return hasTotalBenef
  }
  public consult() {
    this.dispatcher(this.context.proaStore.getSubProjectsInfo(this.getBudgetId()));
  }
  public unSetLoading() {
    this.dispatcherUnsetSetLoading();
  }
  //#endregion
  /********************************************* */
  //#region tables
  public initializeStep1(index: number) {
    this.getReadOnly();
    if (
      this.isContentReady &&
      !Utilities.isNullEmptyObject(this.view.state.dataColumns)
    ) {
      const start = this.view.startDate;

      const bsGridProps = this.getBsGridData(this.currentLabels, {
        columns: this.getDataColumnsBS(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceBs(this.formMasters),
        dataSourceColumns: this.getBsPivotDataSource(this.view.startDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start)
            ? new Date(start).getFullYear()
            : null,
        },
      }, index);
      const bfGridProps = this.getBfGridData(this.currentLabels, {
        columns: this.getDataColumnsBF(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceBf(this.view.startDate),
      }, index);
      const bfmGridProps = this.getBfMGridData(this.currentLabels, {
        columns: this.getDataColumnsBFM(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceBfM(this.view.startDate),
      }, index);
      bfGridProps.summaryRows = this.getSummaries(bfGridProps.columns.slice(1));
      bsGridProps.readOnly = this.view.state.readOnly || false;
      bfGridProps.readOnly = this.view.state.readOnly || false;

      this.view.state.setFirstDataGridProps(bsGridProps);
      this.view.state.setSecondDataGridProps(bfGridProps);
      this.view.state.setThirdDataGridProps(bfmGridProps);
    }
  }
  //#endregion
  /********************************************* */
  //#region save step 1
  public saveStep1(index: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.view.startDate;
    const optionsBs: IDataTable = {
      id: String.Format(Enums.DataGridId.BaseLineFeSt1, index),
      pivotInfo: {
        dataSource: this.getBsPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    const optionsBf: IDataTable = {
      id: String.Format(Enums.DataGridId.BeneficiariesFeSt1, index),
    };
    const dataBs = GridUtilities.getTableData(
      optionsBs,
      Enums.ProaBasicFields.GenericDataId
    );
    const dataBf = GridUtilities.getTableData(
      optionsBf,
      Enums.ProaBasicFields.GenericDataId
    );
    const genericInfo = this.getGenericInfo(dataBs.data, dataBs.grid);
    const beneficiaries = this.getBeneficiaries(dataBf.grid);
    const baseLineYears: Array<IFEStep1Anio> = dataBs.pivotData;
    const step1Data: IFEStep1Dto = {
      genericInfo,
      baseLineYears,
      beneficiaries,
      files: this.view.state.files/*.filter((file: IFileDto) =>
        !Utilities.isNullObject(file.fileRelativeUrl)
      ),*/
    };
    this.saveStep_1(step1Data);
  }
  private saveStep_1(data: IFEStep1Dto) {
    const stepData = { ...data };
    stepData.baseLineYears = data.baseLineYears.map((x: any) => {
      delete x.rowIndex;
      return x;
    });

    const interventionLine = this.formMasters.interventionLines.find((x: any) => x.Id === this.currentBudget.OCTAVIALineaIntervencionId) || null;
    const country_region = this.currentBudget.OCTAVIAPaisId
      ? this.formMasters.countries.find((x: any) => x.Id === this.currentBudget.OCTAVIAPaisId)
      : this.formMasters.regions.find((x: any) => x.Id === this.currentBudget.OCTAVIARegionId);

    const aux = stepData.files.map((file: any) => {
      return {
        ...file,
        PPresLineaInter: interventionLine?.Title || null,
        PProaFinanciador: this.view.state.financers,
        PProaPaisRegion: country_region?.Title || null,
        OCTAVIADatosGeneralesCodigoProyecto: this.currentBudget.PPresCodProy
      }
    })
    stepData.files = aux;
    let userEmail = this.currentUser.currentUser.userPrincipalName;

    this._feService
      .saveFEStep1(stepData, userEmail)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.state.setStep1(undefined)
        this.view.setAlerts(true)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          this.consult()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, stepData).then((guid: string) => {
          Utilities.notifyError(String.Format(this.currentLabels.get("No se pudo guardar el registro"), guid));
        });
      });
  }
  private getGenericInfo(bsItems: any[], bsGrid: DataGrid) {
    return {
      OCTAVIAFechaFinalizacion: moment.utc(this.view.endDate).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
      OCTAVIAFechaInicio: moment.utc(new Date(this.view.startDate)).tz(Constants.GeneralFormats.TIME_ZONE).format(Constants.GeneralFormats.DATE_FORMAT),
      PFFRRLineaBase: bsItems[0].PFFRRLineaBase,
      PProaAnioLineaBase: bsItems[0].PProaAnioLineaBase,
      PPresIndicadorLineaEstrategica1Id: bsGrid.cellValue(0, Enums.ProaBasicFields.IndicadorLE1) ?? null,
      PPresPresupuestoId: this.currentBudget.Id,
      PProaMetaFinal: bsItems[0].PProaMetaFinal,
      Id: bsItems[0].Id,
      PPresCodSubvencionId: bsItems[0].PPresCodSubvencionId,
    };
  }
  private getBeneficiaries(bfGrid: DataGrid) {
    const bfItems = bfGrid.getDataSource().items();
    const beneficiaries: Array<IFEStep1Beneficiario> = [];
    bfItems.forEach((item, index) => {
      const newItem: IFEStep1Beneficiario = {
        PFFRRTotalHombres: bfGrid.cellValue(index, Enums.ProaBasicFields.TotalHombres),
        PFRRTotalMujeres: bfGrid.cellValue(index, Enums.ProaBasicFields.TotalMujeres),
        PPresTotalAnio: bfGrid.cellValue(index, Enums.ProaBasicFields.TotalMeta),
        PPresuAnio: bfGrid.cellValue(index, Enums.ProaBasicFields.BeneficiarioAnio).toString(),
        Id: bfGrid.cellValue(index, Enums.ProaBasicFields.Id),
        PPresPresupuestoId: this.currentBudget.Id
      };
      beneficiaries.push(newItem);
    });
    return beneficiaries;
  }
  //#endregion
  /********************************************* */
  //#region Files
  public addFile(object: any) {
    let existentFiles = this.view.state.files;
    existentFiles.push({
      file: object.file,
      fileName: object.documentName
    } as IFileDto);
    this.view.state.setFile(existentFiles);
    this.openCloseModal();
  }
  public openCloseModal() {
    let openClose = this.view.state.modalOpen ?? false;
    this.view.state.setModalOpen(!openClose);
  }
  public openCloseModalExcel() {
    let openClose = this.view.state.modalExcel ?? false;
    this.view.state.setModalExcel(!openClose);
    this.view.state.setGridDataExcel(null);
  }
  public async deleteDocument(fileName: string) {
    let file = this.view.state.files.find(
      (file: IFileDto) => file.fileName === fileName
    );

    if (!Utilities.isNullObject(file.fileRelativeUrl)) {
      Utilities.showConfirmation(
        this.currentLabels.get("proaDocumentoEliminarMensaje"),
        this.currentLabels.get("proaDocumentoEliminarTitulo"),
        this.currentLabels.get("proaDocumentoEliminarBoton"),
        this.currentLabels.get("Cancelar")
      ).then(async (response: boolean) => {
        if (response) {
          this.dispatcherProgress(0);
          this.dispatcherPendingLoad(1);
          this.dispatcherSetLoading();
          try {
            this.dispatcherProgress(20);
            await this._proaService.deleteFile(file.fileRelativeUrl);
            this.dispatcherProgress(80);
            let files = this.view.state.files.filter((file: IFileDto) => file.fileName !== fileName);
            this.view.state.setFile(files);
            this.dispatcherProgress(99);
            this.dispatcherUnsetSetLoading();
            Utilities.notifySuccess(
              this.currentLabels.get("proaDocumentoEliminarSuccess"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          } catch (error) {
            this.dispatcherProgress(10);
            this.dispatcherUnsetSetLoading();
            this.writeErrorLog(error as Error, { fileName }).then((guid: string) => {
              Utilities.notifyError(String.Format("{0} - {1}", this.currentLabels.get("proaDocumentoEliminarFail"), guid));
            });
          }
        }
      });
    } else {
      Utilities.showConfirmation(
        this.currentLabels.get("proaDocumentoEliminarMensaje"),
        this.currentLabels.get("proaDocumentoEliminarTitulo"),
        this.currentLabels.get("proaDocumentoEliminarBoton"),
        this.currentLabels.get("Cancelar")
      ).then(async (response: boolean) => {
        if (response) {
          try {
            let files = this.view.state.files.filter((file: IFileDto) => file.fileName !== fileName);
            this.view.state.setFile(files);
            Utilities.notifySuccess(
              this.currentLabels.get("proaDocumentoEliminarSuccess"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          } catch (error) {
            Utilities.notifyError(
              this.currentLabels.get("proaDocumentoEliminarFail"),
              this.currentLabels.get("proaDocumentoEliminarTitulo")
            );
          }
        }
      });
    }
  }
  //#endregion
  //#endregion
  /********************************************* */
  //#region Step 2
  //#region tables
  public initializeStep2(index: number) {
    this.getReadOnly();
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const start = this.view.startDate;
      const impGridProps = this.getImpGridData(this.currentLabels, {
        columns: this.getDataColumnsImplementers(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceImp(),
        dataSourceColumns: this.getImpPivotDataSource(this.view.startDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId2,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      }, index);
      impGridProps.summaryRows = this.getSummaries(
        impGridProps.columns.slice(2)
      );
      delete impGridProps.gridProps.stateStoring
      this.view.state.setFirstDataGridProps(impGridProps);
    }
  }
  //#endregion
  /********************************************* */
  //#region save step 2
  public saveStep2(index: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.view.startDate;
    const optionsImp: IDataTable = {
      id: String.Format(Enums.DataGridId.ImplementersfESt2, index),
      pivotInfo: {
        dataSource: this.getImpPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataId2,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    };
    const dataIm = GridUtilities.getTableData(optionsImp, Enums.ProaBasicFields.GenericDataId2);
    let msgAlert = false;
    const genericInfo: Array<IFEStep2DtoModel> = dataIm.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.OCTAVIASLEPId[0])) {
        const implementerYears: Array<IFEStep2Anio> = dataIm.pivotData.filter((y) => y.rowIndex === i).map((y: any) => {
          delete y.rowIndex;
          return y;
        });
        const basicInfo: IFEStep2 = {
          Id: x.Id || 0,
          OCTAVIASLEPId: x.OCTAVIASLEPId[0] || null,
          PPresPresupuestoId: this.currentBudget.Id,
          PProaImplementadorTotal: dataIm.grid.cellValue(i, Enums.ProaBasicFields.TotalImplementadores),
          PPresCodSubvencionId: this.view.state.subventionCodeId,
        };
        return { basicInfo, implementerYears };
      }
      msgAlert = true;
    });
    const step2Data: IFEStep2Dto = {
      genericInfo: genericInfo.filter((x) => !Utilities.isNullEmptyObject(x)),
    };
    if (msgAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_2(step2Data);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_2(step2Data);
    }
  }
  private saveStep_2(step2Data: IFEStep2Dto) {
    this._feService
      .saveFEStep2(step2Data)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.state.setStep2(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          this.consult()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, step2Data).then((guid: string) => {
          Utilities.notifyError(String.Format(this.currentLabels.get("No se pudo guardar el registro"), guid));
        });
      });
  }
  //#endregion
  /********************************************* */
  //#endregion
  /********************************************* */
  //#region Step 3
  //#region tables
  public initializeStep3(index: number) {
    this.getReadOnly();
    if (
      this.isContentReady &&
      !Utilities.isNullEmptyObject(this.view.state.dataColumns)
    ) {
      const start = this.view.startDate;
      const locGridProps = this.getLocGridData(this.currentLabels, {
        columns: this.getDataColumnsLocation(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceLoc(),
        dataSourceColumns: this.getLocPivotDataSource(this.view.startDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      }, index
      );
      locGridProps.summaryRows = this.getSummaries(locGridProps.columns.slice(2));
      const adtGridProps = this.getAdtGridData(this.currentLabels, {
        columns: this.getDataColumnsADT(this.formMasters, this.currentBudget, this.currentBudgetDetails),
        dataSource: this.dataSourceAdt(),
        dataSourceColumns: this.getAdtPivotDataSource(this.view.startDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
        index
      );
      adtGridProps.summaryRows = this.getSummaries(adtGridProps.columns.slice(2));
      this.view.state.setFirstDataGridProps(locGridProps);
      this.view.state.setSecondDataGridProps(adtGridProps);
    }
  }
  //#endregion
  /********************************************* */
  //#region save step 3
  public saveStep3(index: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.view.startDate;
    const optionsLoc: IDataTable = {
      id: String.Format(Enums.DataGridId.LocationsfESt3, index),
      pivotInfo: {
        dataSource: this.getLocPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataId3,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    };
    const optionsADT: IDataTable = {
      id: String.Format(Enums.DataGridId.AdtsfESt3, index),
      pivotInfo: {
        dataSource: this.getAdtPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataId3,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    };
    const dataZC = GridUtilities.getTableData(optionsLoc, Enums.ProaBasicFields.GenericDataId3);
    const dataAd = GridUtilities.getTableData(optionsADT, Enums.ProaBasicFields.GenericDataId3);
    let adtAlert = false;
    let zonesAlert = false;
    const zones: Array<IFEStep3DtoModel> = dataZC.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.PProaLocationId?.[0])) {
        const details: Array<IFEStep3Anios> = dataZC.pivotData.filter((y) => y.rowIndex === i && y.PPresAnioMeta != "null").map((j: any) => {
          delete j.rowIndex;
          return j;
        });
        const genericInfo: IFEStep3 = {
          Id: x.Id || 0,
          PProaLocationId: x.PProaLocationId?.[0] || null,
          PProaAdtId: null,
          PPresPresupuestoId: this.currentBudget.Id,
          PFFRRTotal: dataZC.grid.cellValue(i, Enums.ProaBasicFields.TotalADTLOC),
          PPresCodSubvencionId: this.view.state.subventionCodeId,
        };
        return { details, genericInfo };
      }
      zonesAlert = true;
    });
    const adts: Array<IFEStep3DtoModel> = dataAd.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.PProaAdtId?.[0])) {
        const details: Array<IFEStep3Anios> = dataAd.pivotData.filter((y) => y.rowIndex === i && y.PPresAnioMeta != "null").map((j: any) => {
          delete j.rowIndex;
          return j;
        });
        const genericInfo: IFEStep3 = {
          Id: x.Id || 0,
          PProaLocationId: null,
          PProaAdtId: x.PProaAdtId?.[0] || null,
          PPresPresupuestoId: this.currentBudget.Id,
          PFFRRTotal: dataAd.grid.cellValue(i, Enums.ProaBasicFields.TotalADTLOC),
          PPresCodSubvencionId: this.view.state.subventionCodeId,
        };
        return { details: details, genericInfo: genericInfo };
      }
      adtAlert = true;
    });

    const step3Data: IFEStep3Dto = {
      adts: adts.filter((x) => !Utilities.isNullEmptyObject(x)),
      zones: zones.filter((x) => !Utilities.isNullEmptyObject(x)),
    };

    if (adtAlert || zonesAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_3(step3Data);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_3(step3Data);
    }
  }
  private saveStep_3(step3Data: IFEStep3Dto) {
    this._feService.saveFEStep3(step3Data)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.state.setStep3(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          this.consult()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, step3Data).then((guid: string) => {
          Utilities.notifyError(String.Format(this.currentLabels.get("No se pudo guardar el registro"), guid));
        });
      });
  }
  //#endregion
  //#endregion
  /********************************************* */
  //#endregion
  /********************************************* */
  //#region Step 5
  public initSummaryStep2(index: number) {
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const impGridProps = this.getImplementersSummary(index);
      this.view.state.setFirstDataGridProps(impGridProps);
    }
  }
  public initSummaryStep3(index: number) {
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const locGridProps = this.getLocationsSummary(index);
      this.view.state.setSecondDataGridProps(locGridProps);

      const adtProps = this.getAdtsSummary(index);
      this.view.state.setFifthDataGridProps(adtProps);
    }
  }
  public initSummaryStepSDC(index: number) {
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const sdcGridProps = this.getCounterpartsSummary(index);
      this.view.state.setFourthDataGridProps(sdcGridProps);
    }
  }
  public initSummaryStep4(index: number) {
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const actGridProps = this.getActivitiesSummary(index);
      this.view.state.setThirdDataGridProps(actGridProps);

      const sumActGridProps = this.getActivitiesSummary2(index);
      this.view.state.setSixthDataGridProps(sumActGridProps);
    }
  }

  private getImplementersSummary(index: number) {
    const start = this.view.startDate;
    const impGridProps = this.getSummaryGridData(this.currentLabels, {
      columns: this.getDataColumnsImplementers(
        this.formMasters,
        this.currentBudget,
        this.currentBudgetDetails
      ),
      dataSource: this.dataSourceImp(),
      dataSourceColumns: this.getImpPivotDataSource(this.view.startDate),
      pivotInfo: {
        columnId: Enums.ProaBasicFields.GenericDataId2,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    },
      String.Format(Enums.DataGridId.ImplementersfESt2Summary, index), "Implementadores");
    const newColumns = impGridProps.columns.slice(2);
    const sumItem: any = {};
    newColumns.forEach((column: any, i: number) => {
      if (i < newColumns.length) {
        sumItem[column.dataField] = this.dataSourceSummary(impGridProps.dataSource, column.dataField);
      }
    });
    impGridProps.columns = newColumns;
    impGridProps.dataSource = [sumItem];
    delete impGridProps.gridProps.stateStoring;
    return impGridProps;
  }
  private getLocationsSummary(index: number) {
    const start = this.view.startDate;
    const locGridProps = this.getSummaryGridData(
      this.currentLabels,
      {
        columns: this.getDataColumnsLocation(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceLoc(),
        dataSourceColumns: this.getLocPivotDataSource(this.view.startDate),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
      String.Format(Enums.DataGridId.LocationsfESt3Summary, index), "ZONACCAA"
    );
    const newColumnsLoc = locGridProps.columns.slice(2);
    const sumItemLoc: any = {};
    newColumnsLoc.forEach((column: any, index: number) => {
      if (index < newColumnsLoc.length) {
        sumItemLoc[column.dataField] = this.dataSourceSummary(locGridProps.dataSource, column.dataField);
      }
    });
    locGridProps.columns = newColumnsLoc;
    locGridProps.dataSource = [sumItemLoc];
    return locGridProps;
  }
  private getAdtsSummary(index: number) {
    const start = this.view.startDate;
    const adtGridProps = this.getSummaryGridData(
      this.currentLabels,
      {
        columns: this.getDataColumnsADT(
          this.formMasters,
          this.currentBudget,
          this.currentBudgetDetails
        ),
        dataSource: this.dataSourceAdt(),
        dataSourceColumns: this.getAdtPivotDataSource(start),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataId3,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
      String.Format(Enums.DataGridId.AdtsfESt3Summary, index), "ADT"
    );
    const newColumnsAdt = adtGridProps.columns.slice(2);
    const sumItemAdt: any = {};
    newColumnsAdt.forEach((column: any, index: number) => {
      if (index < newColumnsAdt.length) {
        sumItemAdt[column.dataField] = this.dataSourceSummary(adtGridProps.dataSource, column.dataField);
      }
    });
    adtGridProps.columns = newColumnsAdt;
    adtGridProps.dataSource = [sumItemAdt];
    return adtGridProps;
  }
  private getActivitiesSummary2(index: number) {
    const start = this.view.startDate;
    const actGridPropsData: any = {};
    actGridPropsData.columns = this.getSumActivityColumns(
      this.formMasters,
      this.currentBudget,
      this.currentLabels
    );
    actGridPropsData.dataSource = this.dataSourceSumActivities();
    actGridPropsData.dataSourceColumns = this.getSumActivityPivotDataSource(start);
    actGridPropsData.pivotInfo = {
      columnId: Enums.ProaBasicFields.PProaFEStep4ActividadId,
      columnName: [
        Enums.ProaBasicFields.Meta,
        Enums.ProaBasicFields.SubTotal,
      ],
      columnValue: [
        Enums.ProaBasicFields.MetaValor,
        Enums.ProaBasicFields.SubTotal,
      ],
      start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
    }

    const actGridProps = this.getSummaryGridData(
      this.currentLabels,
      actGridPropsData,
      String.Format(Enums.DataGridId.ActfESt4Summary, index), "Actividades"
    );

    const newColumnsAdt = actGridProps.columns
    const sumItemAdt: any = {};
    newColumnsAdt.forEach((column: any, i: number) => {
      if (i < newColumnsAdt.length) {
        sumItemAdt[column.dataField] = this.dataSourceSummary(actGridProps.dataSource, column.dataField);
      }
    });
    actGridProps.columns = newColumnsAdt;
    actGridProps.dataSource = [sumItemAdt];

    return actGridProps;
  }
  private getActivitiesSummary(index: number) {
    const actGridPropsData: any = {};
    actGridPropsData.columns = this.getDataColumnsSummaryActivities(
      this.formMasters,
      this.currentBudget,
      this.currentLabels
    );
    actGridPropsData.dataSource = this.getActSummaryDataSource(
      this.view.state.step4 || []
    );
    actGridPropsData.summaryRows = [{
      column: actGridPropsData.columns.slice(-1)[0].title,
      summaryType: "sum",
      valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT,
    }];
    actGridPropsData.gridProps = {
      filterPanel: { visible: false },
      groupPanel: { visible: true },
      showHeaderFilter: true,
      columnChooser: { allowSearch: true, enabled: true, mode: "select" },
      headerFilter: { visible: true, allowSearch: true },
    };
    const actGridProps = this.getSummaryGridData(
      this.currentLabels,
      actGridPropsData,
      String.Format(Enums.DataGridId.ActivitiesSummary, index), "Actividades");
    return actGridProps;
  }
  private getCounterpartsSummary(index: number) {
    const start = this.view.startDate;
    const sdcGridProps = this.getSummaryGridData(this.currentLabels, {
      columns: this.getDataColumnsCounterparts(this.formMasters, this.currentBudget),
      dataSource: this.dataSourceSDC(),
      dataSourceColumns: this.getSDCPivotDataSource(this.view.startDate),
      pivotInfo: {
        columnId: Enums.ProaBasicFields.GenericDataIdSDC,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
      },
    },
      String.Format(Enums.DataGridId.CounterpartsStSDCSummary, index ?? ""), "PProaContrapartidas");
    const newColumns = sdcGridProps.columns.slice(3);
    const sumItem: any = {};

    newColumns.forEach((column: any, i: number) => {
      if (i < newColumns.length) {
        sumItem[column.dataField] = this.dataSourceSummary(sdcGridProps.dataSource, column.dataField);
      }
    });
    sdcGridProps.columns = newColumns;
    sdcGridProps.dataSource = [sumItem];
    delete sdcGridProps.gridProps.stateStoring;
    return sdcGridProps;
  }
  //#endregion
  /********************************************* */
  //#region StepSDC
  public initializeStepSDC(index?: number) {
    this.getReadOnly();
    if (this.isContentReady && !Utilities.isNullEmptyObject(this.view.state.dataColumns)) {
      const start = this.view.startDate;
      const contrapartidasGridProps = this.getSDCGridData(this.currentLabels, {
        columns: this.getDataColumnsCounterparts(
          this.formMasters,
          this.currentBudget,
        ),
        dataSource: this.dataSourceSDC(),
        dataSourceColumns: this.getSDCPivotDataSource(
          this.view.startDate
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.GenericDataIdSDC,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: false,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
        gridProps: { wordWrapEnabled: true }
      }, index);
      contrapartidasGridProps.summaryRows = this.getSummaries(contrapartidasGridProps.columns.slice(3));
      delete contrapartidasGridProps.gridProps.stateStoring
      this.view.state.setFirstDataGridProps(contrapartidasGridProps);
    }
  }
  //#region save step SDC
  public saveStepSDC(index?: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    const start = this.view.startDate;
    const optionsSDC: IDataTable = {
      id: String.Format(Enums.DataGridId.CounterpartsStSDC, index ?? ""),
      pivotInfo: {
        dataSource: this.getSDCPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataIdSDC,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: false,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };

    const dataSDC = GridUtilities.getTableData(
      optionsSDC,
      Enums.ProaBasicFields.GenericDataIdSDC
    );
    let msgAlert = false;
    const genericInfo: Array<IFEStepSDCDto> = dataSDC.data.map((x, i) => {
      if (!Utilities.isNullEmptyObject(x.IdContrapartida[0])) {
        let type: string = x.IdContrapartida[0].substring(0, 3);
        let value = (type !== "NEW") ? parseInt(x.IdContrapartida[0].slice(3)) : x.IdContrapartida[0].slice(3);
        const counterpartYears: Array<IFEStepSDCAnio> = dataSDC.pivotData
          .filter((y) => y.rowIndex === i)
          .map((y: any) => {
            delete y.rowIndex;
            return y;
          });
        const basicInfo: IFEStepSDC = {
          Id: x.Id || 0,
          PPresPresupuestoId: this.currentBudget.Id,
          OCTAVIAFinanciadorSapId: type === "FIN" ? value : null,
          OCTAVIACodigoFinanciacionId: type === "COD" ? value : null,
          OCTAVIASLEPId: type === "IMP" ? value : null,
          PProaTipoContrapartidaId: x.PProaTipoContrapartida[0],
          PPresCodSubvencionId: this.view.state.subventionCodeId || null,
          Title: type === "NEW" ? value : String.Empty,
        };
        return { basicInfo, counterpartYears };
      }
      msgAlert = true;
    });
    const stepSDCData: any = {
      budgetId: this.currentBudget.Id,
      genericInfo: genericInfo.filter((x) => !Utilities.isNullEmptyObject(x)),
      genericInfoToDelete: [],
    };
    if (msgAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_SDC(stepSDCData);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_SDC(stepSDCData);
    }
  }
  private saveStep_SDC(stepSDCData: any) {
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    this._feService.saveSPFRStepSDC(stepSDCData, userEmail)
      .then((data) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.state.setStepSDC(undefined)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          this.consult()
        });
      })
      .catch((error: any) => {
        this.writeErrorLog(error, stepSDCData).then((guid: string) => {
          Utilities.notifyError(
            String.Format(
              this.currentLabels.get("No se pudo guardar el registro"),
              guid
            )
          );
        });
      });
  }
  //#endregion
  /********************************************* */
  //#endregion
  /******************************************************************** */
  //#region Step 4
  public initializeStep4Objetives(stepData: IFEStep4Dto[], index: number) {
    this.getReadOnly();
    if (!Utilities.isNullObject(stepData)) {
      let objetives: any[] = [];
      stepData.forEach((element: any, i: number) => {
        const objetive = { ...element };
        objetive.open = objetive.open || false;
        objetive.index = i;
        objetives.push(objetive);
      });
      this.view.state.setStep4Data(stepData);
      this.view.state.setObjetives(objetives);
    } else {
      this.view.state.setStep4Data([]);
      this.view.state.setObjetives([]);
    }
  }
  public initializeStep4GenericData(tabIndex: number, objIndex: number) {
    if (this.isContentReady) {
      const start = this.view.startDate || this.view.state.startDate;
      const objetivesGridProperties = this.getObjetivesGridData(this.currentLabels, {
        columns: this.getSpecificObjetivesColumns(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceSpecificObjetives(),
        dataSourceColumns: this.getSpecificObjetivesPivotDataSource(!Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.PProaFEStep4InidicadorId,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
        tabIndex,
        objIndex,
        this.saveTable
      );
      objetivesGridProperties.summaryRows = this.getSummaries(objetivesGridProperties.columns);
      this.view.state.setObjetivesIndicatorGridData(objetivesGridProperties);
    }
  }
  public initializeStep4MriIndicators(tabIndex: number) {
    let readOnly = this.getReadOnly();
    if (this.isContentReady) {
      const start = this.view.startDate || this.view.state.startDate;
      const mriGridProperties: any = this.getMriIndicatorsGridData(this.currentLabels, {
        columns: this.getMriIndicatorsColumns(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceMriIndicators(this.formMasters),
        dataSourceColumns: this.getMriIndicatorsPivotDataSource(!Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.PProaStep4AdaptacionMRIId,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      }, tabIndex, readOnly, this.saveTable);
      mriGridProperties.summaryRows = this.getSummaries(mriGridProperties.columns);
      mriGridProperties.gridProps.wordWrapEnabled = true;

      // mriGridProperties.auxData = this.view.state.mriIndicatorsGridData?.auxData || []
      this.view.state.setMriIndicatorsGridData(mriGridProperties);
    }
  }
  public missingSLIndicators(mriIndicatorsGridData: any) {
    let countPRInd = 0, hasREInd = false
    let interventionLine = this.currentBudget.OCTAVIALineaIntervencionId
    let dataSource = mriIndicatorsGridData?.dataSource || []

    let strategicLines = this.formMasters.strategicLines.filter((x: any) => x.PRGCodigoLineaIntervencionId === interventionLine)
    let intermediateResults = this.formMasters.intermediateResults.filter((x: any) => {
      let exist = strategicLines?.find((y: any) => x.PFFRRCodigoIndicadorLineaInterveId === y.Id)
      if (exist) return x
    })
    let products = this.formMasters.products.filter((x: any) => {
      let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
      if (exist) return x
    })
    let productsIndicators = this.formMasters.productsIndicators.filter((x: any) => {
      let exist = products?.find((y: any) => x.PFFRRCodigoProductoId === y.Id)
      if (exist) return x
    })
    let intermediateResultsIndicator = this.formMasters.intermediateResultsIndicator.filter((x: any) => {
      let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
      if (exist) return x
    })

    dataSource.forEach((x: any) => {
      if (countPRInd < 2) {
        let exist = productsIndicators.find((y: any) => y.Id === x.PFFRRIndicadorProductoId)
        if (exist) countPRInd++
      }
      if (!hasREInd) {
        hasREInd = !!intermediateResultsIndicator.find((z: any) => (z.Id === x.PFFRRIndicadorResultadoIntermediId?.[0] || z.Id === x.PFFRRIndicadorResultadoIntermediId?.results?.[0]))
      }
    })

    return (countPRInd < 2 || !hasREInd)
  }
  public addNewObjetive(): void {
    let array = this.view?.state?.objetives ? [...this.view.state.objetives] : [];
    let stepData = this.view?.state?.step4Data ? [...this.view.state.step4Data] : [];

    stepData.forEach((value: any) => { value.open = false; });

    array.push({ open: false });
    stepData.push({
      genericInfo: {
        PPresCodSubvencionId: 0,
        PPresPresupuestoId: 0,
        PFFRRTotal: 0,
        PProaObjetivo: "",
      },
      objetives: [],
      results: [],
      open: true
    });

    this.view.state.setObjetives(array);
    this.view.state.setStep4Data(stepData);
  }
  public openObjetive(indexArray: number) {
    let array = [...this.view.state.objetives];
    let finalArray = array.map((value: any) => {
      value.open = false;
      return value;
    });

    finalArray[indexArray].open = true;
    this.view.state.setObjetives(finalArray);
  }
  public get especificObjetive() {
    const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.ObjetivoEspecifico),
      value: (this.view.state.step4Data as IFEStep4Dto[])[this.view.state.index]?.genericInfo?.PProaObjetivo,
      onValueChanged: (data: any) => {
        let objetives: any = [...this.view.state.step4Data];
        objetives[this.view.state.index].genericInfo.PProaObjetivo = data;
        objetives[this.view.state.index].open = true;
        this.view.state.setStep4Data(objetives);
      },
      maxLength: 255,
      lengthRuleMessage: this.currentLabels.get("msjErrorCaracteres"),
    };
    return field;
  }
  public get oeTotal() {
    const field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.TotalOE),
      value: (this.view.state.step4Data as IFEStep4Dto[])[this.view.state.index].genericInfo.PFFRRTotal,
      onValueChanged: (data: any) => {
        let objetives: IFEStep4Dto[] = [...this.view.state.step4Data];
        objetives[this.view.state.index].genericInfo.PFFRRTotal = data;
        this.view.state.setStep4Data(objetives);
      },
    };
    return field;
  }
  public get expectedResult() {
    let field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.PProaResultadoEsperado),
      onValueChanged: (data: any) => {
        let stepData: IFEStep4Dto[] = [...this.view.state.step4Data];
        let intermediateResults: IFEStep4ResultsDtoModel[] = stepData[this.view.state.index].results;
        let specificIntermediateResults: IFEStep4ResultsDtoModel = intermediateResults[this.view.state.indexTab];
        specificIntermediateResults.genericInfo.PProaResultadoEsperado = data;
        stepData[this.view.state.index].results[this.view.state.indexTab] = specificIntermediateResults;
        this.view.state.setStep4Data(stepData);
      },
      maxLength: 255,
      lengthRuleMessage: this.currentLabels.get("msjErrorCaracteres"),
    };
    field.value = (this.view.state.step4Data as IFEStep4Dto[])[this.view.state.index]?.results[this.view.state.indexTab]?.genericInfo?.PProaResultadoEsperado ?? "";
    return field;
  }
  public get oeTotalExpectedResult() {
    let field = {
      ...this.getCommonFieldProps(Enums.ProaBasicFields.TotalOE),
      onValueChanged: (data: any) => this.view.state.setTotalExpertResult(data),
      readOnly: true,
    };
    field.value = this.view.state.totalExpertResult;
    return field;
  }

  public saveGenericInfoObjetiveStep4(tabIndex: number, index: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    let dataToSave: IFEStep4 = this.mapBasicDataToDTO(index)
    if (!!dataToSave && dataToSave?.PProaObjetivo == "") {
      Utilities.notifyError('Debe asignar un nombre al objetivo', 'Error');
      return;
    }
    let stepData: IFEStep4Dto[] = [...this.view.state.step4Data];
    this._feService
      .saveGenericInfoObjetiveStep4(dataToSave, userEmail)
      .then((response) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        stepData[this.view.state.index].genericInfo = response
        this.view.state.setStep4Data(stepData);
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          if (tabIndex >= 0) this.consult?.()
        });
      })
  }

  public saveGenericInfoREStep4(tabIndex: number, objIndex: number, resultIndex: number) {
    Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    let objetive: IFEStep4 = this.mapBasicDataToDTO(objIndex)
    if (!!objetive && !objetive?.Id) {
      Utilities.notifyError('Debe guardar primero la información básica del objetivo', 'Error');
      return;
    }
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    let dataToSave: IFEStep4ResultadoEsperado = this.mapBasicDataREToDTO(objetive, objIndex, resultIndex)
    if (!!dataToSave && dataToSave?.PProaResultadoEsperado == "") {
      Utilities.notifyError('Debe asignar un nombre al resultado esperado', 'Error');
      return;
    }
    let stepData: IFEStep4Dto[] = [...this.view.state.step4Data];
    this._feService
      .saveGenericInfoREStep4(dataToSave, userEmail)
      .then((result) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        stepData[objIndex].results[resultIndex].genericInfo = result
        this.view.state.setStep4Data(stepData);
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          if (tabIndex >= 0) this.consult?.()
        });
      })
  }

  public saveStep4(tabIndex: number) {
    // Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
    let dataToSave: IFEStep4Dto[] = this.view.state.objetives.map(
      (objetive: any, index: number) => {
        return {
          genericInfo: this.mapBasicDataToDTO(index),
          objetives: this.mapBasicDataObjetivesTableToDTO(index, tabIndex),
          results: this.mapExpectedResultsToDTO(tabIndex, index),
        } as IFEStep4Dto;
      }
    );
    dataToSave = dataToSave.filter((x) => x.genericInfo.PProaObjetivo !== "");

    let mriToSave: IFEStep4MriIndicadorDtoModel[] = this.mapBasicDataMriTableToDTO(tabIndex);

    let msgAlert = false;
    mriToSave.forEach((item) => {
      if (!item) msgAlert = true;
    });
    mriToSave = mriToSave.filter((x) => x);

    console.log(dataToSave)

    /* if (msgAlert) {
      const title = this.currentLabels.get("alertMsgLocationTitle");
      const msg = this.currentLabels.get("alertMsgLocation");
      Utilities.showConfirmation(msg, title).then((response) => {
        if (response) {
          this.saveStep_4(dataToSave, mriToSave, tabIndex >= 0);
          Utilities.showLoading(this.currentLabels.get("savingMessage"), this.currentLabels.get("loadingMessage"))
        }
      });
    } else {
      this.saveStep_4(dataToSave, mriToSave, tabIndex >= 0);
    } */
  }

  private saveStep_4(dataToSave: IFEStep4Dto[], mriToSave: IFEStep4MriIndicadorDtoModel[], isFFCC?: boolean) {
    let userEmail = this.currentUser.currentUser.userPrincipalName;
    this._feService
      .saveFEStep4(dataToSave, mriToSave, userEmail)
      .then((response) => {
        const title = this.currentLabels.get("Guardar");
        const msg = this.currentLabels.get("Guardado exitoso");
        this.view.state.setStep4Data?.(undefined)
        this.view.state.setObjetives?.(undefined)
        this.view.state.setStepMriData?.(mriToSave)
        this.view.setShowAlerts(true)
        Utilities.notifySuccess(msg, title).then((x) => {
          this.view.state.handleSwitch?.();
          if (isFFCC) this.consult?.()
        });
      })
      .catch((error) => {
        this.writeErrorLog(error, dataToSave).then((guid: string) => {
          Utilities.notifyError(String.Format(this.currentLabels.get("No se pudo guardar el registro"), guid));
        });
      });
  }

  public addNewExpectedResult() {
    let stepData = [...this.view.state.step4Data];
    stepData.forEach((value: any) => { value.open = false; });
    let stepDataPosition: any = stepData[this.view.state.index];

    stepDataPosition.results.push(this.generateNewExpectedResult());
    stepDataPosition.open = true
    stepData[this.view.state.index] = stepDataPosition;
    this.view.state.setStep4Data(stepData);
  }
  public expectedResultGridData(
    tabIndex: number,
    objIndex: number,
    resIndex: number
  ) {
    if (this.isContentReady) {
      const start = this.view.startDate;
      const expectedResultGridProperties = this.getExpectedResultsGridData(
        this.currentLabels, {
        columns: this.getExpectedResultsColumns(
          this.formMasters,
          this.currentBudget
        ),
        dataSource: this.dataSourceExpectedResults(),
        dataSourceColumns: this.getExpectedResultsPivotDataSource(
          !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
          objIndex, resIndex),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.PProaFEStep4ResultadoDetalleId,
          columnName: [Enums.ProaBasicFields.Meta],
          columnValue: [Enums.ProaBasicFields.MetaValor],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
        tabIndex,
        objIndex,
        resIndex,
        this.saveTable
      );
      expectedResultGridProperties.summaryRows = this.getSummaries(
        expectedResultGridProperties.columns
      );
      this.view.state.setExpectedResultsGridData(expectedResultGridProperties);
    }
  }
  public activitiesGridData(
    tabIndex: number,
    objIndex: number,
    resIndex: number
  ) {
    if (this.isContentReady) {
      const start = this.view.startDate;
      const activityGridProperties = this.getActivitiesGridData(
        this.currentLabels, {
        columns: this.getActivityColumns(this.formMasters, this.currentBudget),
        dataSource: this.dataSourceActivities(),
        dataSourceColumns: this.getActivityPivotDataSource(
          !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
          objIndex,
          resIndex
        ),
        pivotInfo: {
          columnId: Enums.ProaBasicFields.PProaFEStep4ActividadId,
          columnName: [
            Enums.ProaBasicFields.Meta,
            Enums.ProaBasicFields.SubTotal,
          ],
          columnValue: [
            Enums.ProaBasicFields.MetaValor,
            Enums.ProaBasicFields.SubTotal,
          ],
          joinTitle: true,
          start: !Utilities.isNullEmptyObject(start) ? new Date(start).getFullYear() : null,
        },
      },
        tabIndex,
        objIndex,
        resIndex,
        this.saveTable
      );
      activityGridProperties.summaryRows = this.getSummaries(
        activityGridProperties.columns
      );
      this.view.state.setActivitiesGridData(activityGridProperties);
    }
  }
  private mapBasicDataToDTO(objIndex: number) {
    this.dispatcherProgress(20);
    let data = this.view.state.step4Data[objIndex];
    return {
      Id: data?.genericInfo?.Id ?? 0,
      PProaObjetivo: data?.genericInfo?.PProaObjetivo ?? "",
      PFFRRTotal: data?.genericInfo?.PFFRRTotal ?? 0,
      PPresCodSubvencionId: this._subventionCodeId,
      PPresPresupuestoId: this.currentBudget.Id,
    } as IFEStep4;
  }

  private mapBasicDataREToDTO(objetive: IFEStep4, objIndex: number, resultIndex: number) {
    let data: IFEStep4ResultsDtoModel = this.view.state.step4Data[objIndex]?.results[resultIndex];
    return {
      Id: data?.genericInfo?.Id ?? 0,
      PFFRRTotal: data?.genericInfo?.PFFRRTotal ?? 0,
      PProaFEStep4Id: objetive.Id,
      PProaResultadoEsperado: data?.genericInfo?.PProaResultadoEsperado
    } as IFEStep4ResultadoEsperado
  }

  private mapBasicDataObjetivesTableToDTO(objIndex: number, tabIndex: number) {
    const optionsObjetivesTable: IDataTable = {
      id: String.Format(Enums.DataGridId.SpecificObjetives, tabIndex, objIndex),
      pivotInfo: {
        dataSource: this.getSpecificObjetivesPivotDataSource(objIndex),
        columnId: Enums.ProaBasicFields.PProaFEStep4InidicadorId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: null,
      },
    };
    let dataResult = GridUtilities.getTableData(optionsObjetivesTable, Enums.ProaBasicFields.PProaFEStep4InidicadorId);
    let results = dataResult.data.map((data: any, index: number) => {
      let genericInfo = {
        Id: data?.Id ?? 0,
        PProaFEStep4Id: data?.PProaFEStep4Id ?? 0,
        PProaIndicadorObjetivo: data?.PProaIndicadorObjetivo ?? "",
        PProaMedidaId: data?.PProaMedidaId || null,
        PFFRRLineaBase: data?.PFFRRLineaBase ? Number(Number(data?.PFFRRLineaBase)?.toFixed(2)) : data?.PFFRRLineaBase,
        PProaAnioLineaBase: data?.PProaAnioLineaBase,
        PProaMetaFinanciera: data?.PProaMetaFinanciera ? Number(Number(data?.PProaMetaFinanciera)?.toFixed(2)) : data?.PProaMetaFinanciera ?? null
      } as IFEStep4IndicadorObjetivo;

      genericInfo.PProaMedidaId = Array.isArray(genericInfo.PProaMedidaId) ? genericInfo.PProaMedidaId.length > 0 ? genericInfo.PProaMedidaId[0] : null : genericInfo.PProaMedidaId;

      let years: Array<IFEStep4IndicadorObjetivoAnio> = dataResult.pivotData
        .filter((x: any) => x.rowIndex === index)
        .map((dataYear: any) => {
          return {
            Id: dataYear.Id,
            PPresAnioMeta: dataYear.PPresAnioMeta,
            PProaAnioValue: dataYear.PProaAnioValue,
            PProaFEStep4InidicadorId: data?.PProaFEStep4InidicadorId ?? 0,
          } as IFEStep4IndicadorObjetivoAnio;
        });

      return {
        genericInfo,
        years,
      };
    });
    this.dispatcherProgress(30);
    return results.filter((x) => x.genericInfo.PProaIndicadorObjetivo !== "" && (x.genericInfo.PProaIndicadorObjetivo as any) !== 0);
  }

  private mapBasicDataMriTableToDTO(tabIndex: number) {
    let budgetId = this.getBudgetId();
    let subventionCodeId = this._subventionCodeId || this.view.state.subventionCodeId;

    const mriTable: IDataTable = {
      id: String.Format(Enums.DataGridId.MriIndicators, tabIndex),
      pivotInfo: {
        dataSource: this.getMriIndicatorsPivotDataSource(),
        columnId: Enums.ProaBasicFields.PProaStep4AdaptacionMRIId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: null,
      },
    };
    let dataResult = GridUtilities.getTableData(mriTable, Enums.ProaBasicFields.PProaStep4AdaptacionMRIId);
    let results = dataResult.data.map((data: any, index: number) => {
      let genericInfo = {
        Id: data?.Id ?? 0,
        PPresPresupuestoId: budgetId,
        PPresCodSubvencionId: subventionCodeId,

        PFFRRIndicadorProductoId: data?.PFFRRIndicadorProductoId ?? 0,
        PFFRRIndicadorResultadoIntermedioId: data?.PFFRRIndicadorResultadoIntermedioId ?? 0,
        PPresIndicadorLineaEstrategicaId: data?.PPresIndicadorLineaEstrategicaId ?? 0,
        PProaDescripcion: data?.PProaDescripcion || "",
        PFFRRLineaBase: data?.PFFRRLineaBase ? Number(Number(data?.PFFRRLineaBase)?.toFixed(2)) : data?.PFFRRLineaBase,
        PProaAnioLineaBase: data?.PProaAnioLineaBase,
        PProaMetaMRI: data?.PProaMetaMRI ? Number(Number(data?.PProaMetaMRI)?.toFixed(2)) : data?.PProaMetaMRI ?? null,
      } as IFEStep4IndicadorMri;

      if (data?.PProaMRIPriority) {
        let value = null;
        if (Array.isArray(data.PProaMRIPriority)) {
          value = data.PProaMRIPriority[0];
        } else {
          value = data.PProaMRIPriority;
        }

        if (value !== undefined && value !== null) {
          if (value.includes(Constants.Globals.PREFIX_INTERMEDIATE_RESULTS)) {
            genericInfo.PFFRRIndicadorResultadoIntermedioId = [Number(value.replace(Constants.Globals.PREFIX_INTERMEDIATE_RESULTS, ""))] as any;
            genericInfo.PPresIndicadorLineaEstrategicaId = null;
            genericInfo.PFFRRIndicadorProductoId = null;
          } else if (value.includes(Constants.Globals.PREFIX_PRODUCT_INDICATOR)) {
            genericInfo.PFFRRIndicadorProductoId = Number(value.replace(Constants.Globals.PREFIX_PRODUCT_INDICATOR, ""));
            genericInfo.PFFRRIndicadorResultadoIntermedioId = [] as any;
            genericInfo.PPresIndicadorLineaEstrategicaId = null;
          } else {
            genericInfo.PPresIndicadorLineaEstrategicaId = Number(value.replace(Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR, ""));
            genericInfo.PFFRRIndicadorProductoId = null;
            genericInfo.PFFRRIndicadorResultadoIntermedioId = [] as any;
          }
        } else {
          genericInfo.PFFRRIndicadorProductoId = null;
          genericInfo.PPresIndicadorLineaEstrategicaId = null;
          genericInfo.PFFRRIndicadorResultadoIntermedioId = [] as any;
        }

        if (value) {
          let years: Array<IFEStep4MriIndicadorAnio> = dataResult.pivotData
            .filter((x: any) => x.rowIndex === index)
            .map((dataYear: any) => {
              return {
                Id: dataYear.Id,
                PPresAnioMeta: dataYear.PPresAnioMeta,
                PProaAnioValue: dataYear.PProaAnioValue,
                PProaStep4AdaptacionMRIId: data?.PProaStep4AdaptacionMRIId ?? 0,
              } as IFEStep4MriIndicadorAnio;
            });

          return {
            genericInfo,
            years,
          };
        }
      }
    });
    this.dispatcherProgress(45);
    return results;
  }
  private mapIntermediateResultsTableToDTO(
    tabIndex: number,
    objIndex: number,
    resIndex: number
  ): any {
    const optionsObjetivesTable: IDataTable = {
      id: String.Format(Enums.DataGridId.ExpectedResults, tabIndex, objIndex, resIndex),
      pivotInfo: {
        dataSource: this.getExpectedResultsPivotDataSource(this.view.startDate, objIndex, resIndex),
        columnId: Enums.ProaBasicFields.PProaFEStep4ResultadoDetalleId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: null,
      },
    };
    let dataResult = GridUtilities.getTableData(optionsObjetivesTable, Enums.ProaBasicFields.PProaFEStep4ResultadoDetalleId);
    let fullData = dataResult.data.map((data: any, index: number) => {
      let genericInfo = {
        Id: data?.Id ?? 0,
        PProaFEStep4ResultadosEsperadosId: data?.PProaFEStep4ResultadosEsperadosId ?? 0,
        PProaIndicadorResultadoEsperado: data?.PProaIndicadorResultadoEsperado ?? "",
        PProaMedidaId: data?.PProaMedidaId ?? null,
        PFFRRLineaBase: data?.PFFRRLineaBase ? Number(Number(data?.PFFRRLineaBase)?.toFixed(2)) : data?.PFFRRLineaBase,
        PProaAnioLineaBase: data?.PProaAnioLineaBase,
        PProaMetaFinanciera: data?.PProaMetaFinanciera ? Number(Number(data?.PProaMetaFinanciera)?.toFixed(2)) : data?.PProaMetaFinanciera ?? null
      } as IFEStep4ResultadoEsperadoDetalle;

      genericInfo.PProaMedidaId = Array.isArray(genericInfo.PProaMedidaId) ? genericInfo.PProaMedidaId.length > 0 ? genericInfo.PProaMedidaId[0] : null : genericInfo.PProaMedidaId;

      let years: Array<IFEStep4ResultadoEsperadoDetalleAnio> = dataResult.pivotData
        .filter((x: any) => x.rowIndex === index)
        .map((dataYear: any) => {
          return {
            Id: dataYear.Id,
            PPresAnioMeta: dataYear.PPresAnioMeta,
            PProaAnioValue: dataYear.PProaAnioValue,
            PProaFEStep4ResultadoDetalleId: dataYear?.PProaFEStep4ResultadoDetalleId ?? 0,
          } as IFEStep4ResultadoEsperadoDetalleAnio;
        });

      return {
        genericInfo,
        years,
      };
    });

    return fullData.filter((x) => x.genericInfo.PProaIndicadorResultadoEsperado !== "" && (x.genericInfo.PProaIndicadorResultadoEsperado as any) !== 0);
  }
  private mapActivitiesTableToDTO(tabIndex: number, objIndex: number, resIndex: number, isModified: boolean = false): any {
    const optionsObjetivesTable: IDataTable = {
      id: String.Format(Enums.DataGridId.Activities, tabIndex, objIndex, resIndex),
      pivotInfo: {
        dataSource: this.getActivityPivotDataSource(this.view.startDate, objIndex, resIndex),
        columnId: Enums.ProaBasicFields.PProaFEStep4ActividadId,
        columnName: [
          Enums.ProaBasicFields.Meta,
          Enums.ProaBasicFields.SubTotal
        ],
        columnValue: [
          Enums.ProaBasicFields.MetaValor,
          Enums.ProaBasicFields.SubTotal
        ],
        joinTitle: true,
        start: null,
      },
    };
    let dataResult = GridUtilities.getTableData(
      optionsObjetivesTable,
      Enums.ProaBasicFields.PProaFEStep4ActividadId
    );

    let fullData = dataResult.data.map((data: any, index: number) => {
      let genericInfo = {
        Id: data?.Id ?? 0,
        PProaActividad: data?.PProaActividad ?? "",
        PProaMedidaId: data?.PProaMedidaId ?? null,
        PProaMetaTotalProyecto: data?.PProaMetaTotalProyecto ? Number(Number(data?.PProaMetaTotalProyecto)?.toFixed(2)) : data?.PProaMetaTotalProyecto ?? null,
        PProaValorActividad: data?.PProaValorActividad ? Number(Number(data?.PProaValorActividad)?.toFixed(2)) : data?.PProaValorActividad ?? null,
        PProaFEStep4ResultadosEsperadosId: data?.PProaFEStep4ResultadosEsperadosId ?? 0,
      } as IFEStep4Actividad;

      if (isModified) genericInfo.isModified = data.isModified;

      genericInfo.PProaMedidaId = Array.isArray(genericInfo.PProaMedidaId) ? genericInfo.PProaMedidaId.length > 0 ? genericInfo.PProaMedidaId[0] : null : genericInfo.PProaMedidaId;

      let years: Array<IFEStep4ActividadAnio> = dataResult.pivotData
        .filter((x: any) => x.rowIndex === index)
        .map((dataYear: any) => {
          return {
            Id: dataYear.Id,
            PPresAnioMeta: dataYear.PPresAnioMeta,
            PProaAnioValue: dataYear.PProaAnioValue,
            PFFRRSubTotal: dataYear.PFFRRSubTotal,
            PProaFEStep4ActividadId: dataYear?.PProaFEStep4ActividadId ?? 0,
          } as IFEStep4ActividadAnio;
        });

      return {
        genericInfo,
        years,
      };
    });
    return fullData.filter((x) => x.genericInfo.PProaActividad !== "" && (x.genericInfo.PProaActividad as any) !== 0);
  }
  private mapExpectedResultsToDTO(tabIndex: number, objIndex: number, isModified: boolean = false) {
    let data: IFEStep4Dto = this.view.state.step4Data[objIndex];
    data.results.forEach((result: IFEStep4ResultsDtoModel, resIndex: number) => {
      data.results[resIndex].details = this.mapIntermediateResultsTableToDTO(tabIndex, objIndex, resIndex);
      data.results[resIndex].activities = this.mapActivitiesTableToDTO(tabIndex, objIndex, resIndex, isModified);
    }
    );
    this.dispatcherProgress(40);
    return data.results;
  }
  private generateNewExpectedResult() {
    return {
      genericInfo: {
        PFFRRTotal: 0,
        PProaFEStep4Id: 0,
        PProaResultadoEsperado: "",
        Id: 0,
      },
      activities: [],
      details: [],
    } as IFEStep4ResultsDtoModel;
  }
  public testRender(item: any, checkLE: boolean) {
    let dataSource = this.dataSourceMriIndicators(this.formMasters)
    let auxItems: any[] = []
    if (!!item.auxData?.length) {
      let newItems = item.dataSource?.filter((x: any) => {
        let addToData = (!!x.__KEY__) ? !item.auxData.find((y: any) => y.__KEY__ === x.__KEY__) : false
        if (addToData) return x;
      }) || []
      let newItems2 = dataSource?.filter((x: any) => {
        let addToData = (!!x.Id) ? !item.auxData.find((y: any) => y.Id === x.Id) : false
        if (addToData) return x;
      }) || []
      item.auxData = [...item.auxData, ...newItems, ...newItems2] || []
    } else item.auxData = item.dataSource || []

    item.dataSource = item.auxData

    if (checkLE) {
      let idStrategicLineStep1 = this.view.state.step1?.genericInfo?.PPresIndicadorLineaEstrategica1Id;
      let interventionLine = this.currentBudget.OCTAVIALineaIntervencionId

      let strategicLines = this.formMasters.strategicLines.filter((x: any) => x.PRGCodigoLineaIntervencionId === interventionLine)
      let intermediateResults = this.formMasters.intermediateResults.filter((x: any) => {
        let exist = strategicLines?.find((y: any) => x.PFFRRCodigoIndicadorLineaInterveId === y.Id)
        if (exist) return x
      })
      let products = this.formMasters.products.filter((x: any) => {
        let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
        if (exist) return x
      })
      let productsIndicators = this.formMasters.productsIndicators.filter((x: any) => {
        let exist = products?.find((y: any) => x.PFFRRCodigoProductoId === y.Id)
        if (exist) return x
      })
      let intermediateResultsIndicator = this.formMasters.intermediateResultsIndicator.filter((x: any) => {
        let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
        if (exist) return x
      })

      auxItems = [
        ...Utilities.processDropDownData(strategicLines.filter((x: any) => x.Id !== idStrategicLineStep1), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
        ...Utilities.processDropDownData(intermediateResultsIndicator, "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
        ...Utilities.processDropDownData(productsIndicators, "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
      ];

      item.dataSource = item.dataSource.filter((x: any) => {
        let exist = auxItems.find((y: any) => (y.id === x.PProaMRIPriority || y.id === x.PProaMRIPriority?.[0]))
        if (exist) return x;
      })

      if (item.dataSource.length === 0) {
        item.dataSource.push({
          PFFRRIndicadorProductoId: 0,
          PFFRRIndicadorResultadoIntermedioId: 0,
          PPresIndicadorLineaEstrategicaId: 0,
          PProaDescripcion: "",
          PProaUnidadMedida: "",
          PFFRRLineaBase: null,
          PProaAnioLineaBase: null,
          PProaMetaMRI: 0
        } as IFEStep4IndicadorMri);
      }
    }
    this.view.state.setMriIndicatorsGridData(item)
  }
  public onCellPreRender(data: any, column: BatchGridColumnProps, validStrategicLine: boolean): BatchGridColumnProps {
    const newColumn: BatchGridColumnProps = { ...column };
    let idStrategicLineStep1 = this.view.state.step1?.genericInfo?.PPresIndicadorLineaEstrategica1Id;

    if (column.dataField === Enums.ProaBasicFields.PProaMedidaId) {
      let items = Utilities.processDropDownData(this.formMasters.measureUnits.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.MeasureUnits);
      let allItems = Utilities.processDropDownData(this.formMasters.measureUnits, Enums.ListTypes.MeasureUnits);

      newColumn.items = items;
      newColumn.allItems = allItems;
    }

    if (column.dataField === Enums.ProaBasicFields.IndicadorLE1) {
      let auxItems = Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.StrategicLine);
      let newItems: any[] = []

      if (column.items?.length) {
        column.items.forEach(x => {
          let findItem = auxItems.find((y: any) => y.id === x.id)
          if (findItem) newItems.push(x)
        })
      }

      newColumn.allItems = column.items;
      newColumn.items = newItems;
    }

    if (column.dataField === Enums.ProaBasicFields.PProaMRIPriority) {
      const allItems = [
        ...Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => x.Id !== idStrategicLineStep1), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
        ...Utilities.processDropDownData(this.formMasters.intermediateResultsIndicator, "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
        ...Utilities.processDropDownData(this.formMasters.productsIndicators, "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
      ];
      const items = [
        ...Utilities.processDropDownData(this.formMasters.strategicLines.filter((x: any) => x.Id !== idStrategicLineStep1 && x.OCTAVIAActivo), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
        ...Utilities.processDropDownData(this.formMasters.intermediateResultsIndicator.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
        ...Utilities.processDropDownData(this.formMasters.productsIndicators.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
      ];

      let auxItems: any = []

      if (validStrategicLine) {
        let interventionLine = this.currentBudget.OCTAVIALineaIntervencionId

        let strategicLines = this.formMasters.strategicLines.filter((x: any) => x.PRGCodigoLineaIntervencionId === interventionLine)
        let intermediateResults = this.formMasters.intermediateResults.filter((x: any) => {
          let exist = strategicLines?.find((y: any) => x.PFFRRCodigoIndicadorLineaInterveId === y.Id)
          if (exist) return x
        })
        let products = this.formMasters.products.filter((x: any) => {
          let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
          if (exist) return x
        })
        let productsIndicators = this.formMasters.productsIndicators.filter((x: any) => {
          let exist = products?.find((y: any) => x.PFFRRCodigoProductoId === y.Id)
          if (exist) return x
        })
        let intermediateResultsIndicator = this.formMasters.intermediateResultsIndicator.filter((x: any) => {
          let exist = intermediateResults?.find((y: any) => x.PFFRRCodigoResultadoIntermedioId === y.Id)
          if (exist) return x
        })

        auxItems = [
          ...Utilities.processDropDownData(strategicLines.filter((x: any) => x.Id !== idStrategicLineStep1 && x.OCTAVIAActivo), "", "", Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR),
          ...Utilities.processDropDownData(intermediateResultsIndicator.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_INTERMEDIATE_RESULTS),
          ...Utilities.processDropDownData(productsIndicators.filter((x: any) => (x.OCTAVIAActivo)), "", "", Constants.Globals.PREFIX_PRODUCT_INDICATOR),
        ];
      }

      newColumn.items = validStrategicLine ? auxItems : items;
      newColumn.allItems = allItems;
    }
    if (
      column.dataField === Enums.ProaBasicFields.IndicadorProducto &&
      !Utilities.isNullEmptyObject(data.data.PFFRRCodigoProductoId)
    ) {
      const codProd = data.data.PFFRRCodigoProductoId[0];
      const items = this.formMasters.productsIndicators.filter(
        (x: any) => x.PFFRRCodigoProductoId === codProd
      );
      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProductsIndicator
      );
      newColumn.readOnly = false;
    }

    if (column.dataField === Enums.ProaBasicFields.PProaTipoContrapartida) {
      data.data.IdContrapartida = [];
      let isDonation = false;
      let isGrant = false;
      let grantCode = this.view.state.grantCode;
      let isCodeFE: boolean = !Utilities.isNullEmptyObject(grantCode);
      if (isCodeFE) {
        if (grantCode?.trim()[0] === Enums.Prefix.Donations.toString()) isDonation = true;
        if (![Enums.Prefix.Donations.toString(), Enums.Prefix.Contributions.toString()].includes(grantCode?.trim()[0])) isGrant = true;
        let projectsGrouped = this.view.state.projectsGrouped.filter((y: any) => y.PPresCodSubvencion?.Title?.trim() == grantCode)
        if (projectsGrouped.length) {
          projectsGrouped[0].SubProyectosAgrupados.forEach((prGrouped: any) => {
            if (prGrouped.Title?.trim()[0] === Enums.Prefix.Donations.toString()) isDonation = true;
            if (![Enums.Prefix.Donations.toString(), Enums.Prefix.Contributions.toString()].includes(prGrouped.Title?.trim()[0])) isGrant = true;
          });
        }
      }
      const items = this.formMasters.counterpartType.filter((x: any) => {
        if (
          (isCodeFE && x.ActivoFC && [Enums.CounterpartsType.Donation].includes(x.Title?.trim()) && isDonation) ||
          (isCodeFE && x.ActivoFC && [Enums.CounterpartsType.Grant].includes(x.Title?.trim()) && isGrant) ||
          (![Enums.CounterpartsType.Donation, Enums.CounterpartsType.Grant].includes(x.Title?.trim()) && isCodeFE && x.ActivoFC) ||
          (!isCodeFE && x.ActivoFR)
        ) {
          return x;
        }
      });
      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProaTipoContrapartida
      );
    }

    if (column.dataField === Enums.ProaBasicFields.IdContrapartida) {
      newColumn.acceptCustomValue = false;
      let items: any[] = [];
      let prefix: string = "";

      if (data?.data?.PProaTipoContrapartida) {
        let typeId = data?.data?.PProaTipoContrapartida[0]
        let grantCode = this.view.state.grantCode;

        switch (typeId) {
          case 1:
            items = this.formMasters.ffrrFinancer.filter((x: any) => (x.OCTAVIAActivo))
            prefix = "FIN"
            break;
          case 2:
            let projectsGroupedS = this.view.state.projectsGrouped.filter((y: any) => y.PPresCodSubvencion?.Title == grantCode)
            if (projectsGroupedS.length) {
              projectsGroupedS[0].SubProyectosAgrupados.forEach((prGrouped: any) => {
                if (![Enums.Prefix.Donations.toString(), Enums.Prefix.Contributions.toString()].includes(prGrouped.Title?.trim()[0]))
                  items.push({ ID: prGrouped.Id, Title: prGrouped.Title })
              })
            }
            if (![Enums.Prefix.Donations.toString(), Enums.Prefix.Contributions.toString()].includes(this.view.state.grantCode?.trim()[0]))
              items.unshift({ ID: this.view.state.subventionCodeId, Title: this.view.state.grantCode });
            prefix = "COD";
            break;
          case 3:
            let projectsGroupedD = this.view.state.projectsGrouped.filter((y: any) => y.PPresCodSubvencion?.Title == grantCode)
            if (projectsGroupedD.length) {
              projectsGroupedD[0].SubProyectosAgrupados.forEach((prGrouped: any) => {
                if ([Enums.Prefix.Donations.toString()].includes(prGrouped.Title?.trim()[0]))
                  items.push({ ID: prGrouped.Id, Title: prGrouped.Title })
              })
            }
            if ([Enums.Prefix.Donations.toString()].includes(this.view.state.grantCode?.trim()[0]))
              items.unshift({ ID: this.view.state.subventionCodeId, Title: this.view.state.grantCode });
            prefix = "COD";
            break;
          case 4:
            if (this.view.implementersData) {
              let arrayExcluded = this.params[Enums.Params.impCodesExcludedCounterpart]?.split(',') || [];
              this.view.implementersData.genericInfo.forEach((x: any) => {
                if (x.basicInfo.OCTAVIASLEP) {
                  let impData = this.formMasters.implementators.find((y: any) => (x.basicInfo.OCTAVIASLEP.Id === y.Id && y.OCTAVIAActivo));
                  if (!arrayExcluded.includes(impData?.OCTAVIACodigo) && impData)
                    items.push({ ID: x.basicInfo.OCTAVIASLEP.Id, Title: x.basicInfo.OCTAVIASLEP.Title })
                }
              });
            }
            prefix = "IMP"
            break;
          case 5:
            newColumn.acceptCustomValue = true;
            if (data.value?.length) {
              const newItem = {
                Title: data.value[0].slice(3),
                ID: data.value[0]
              };
              items = [newItem]
            }
            break;
        }
      }

      newColumn.items = Utilities.processDropDownData(
        items,
        Enums.ListTypes.ProaSubproyectoFRStepSDC,
        "",
        prefix
      );
    }
    return newColumn;
  }


  private getStep1GenericInfo(tabIndex: number): any {
    const start = this.view.startDate;
    const optionsBs: IDataTable = {
      id: String.Format(Enums.DataGridId.BaseLineFeSt1, tabIndex),
      pivotInfo: {
        dataSource: this.getBsPivotDataSource(this.view.startDate),
        columnId: Enums.ProaBasicFields.GenericDataId,
        columnName: [Enums.ProaBasicFields.Meta],
        columnValue: [Enums.ProaBasicFields.MetaValor],
        joinTitle: true,
        start: !Utilities.isNullEmptyObject(start)
          ? new Date(start).getFullYear()
          : null,
      },
    };
    const dataBs = GridUtilities.getTableData(
      optionsBs,
      Enums.ProaBasicFields.GenericDataId
    );
    return this.getGenericInfo(dataBs.data, dataBs.grid);
  }

  //#endregion
}
